import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useEffect,
  useState,
} from "react";
import { Table, Typography, Row, Col, Card } from "antd";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import moment from "moment";
import { Footer } from "antd/lib/layout/layout";

const { Title } = Typography;

const MyTable = forwardRef((props, ref) => {
  console.log("props", props);
  const [visible, setVisible] = useState(false);
  const tableRef = useRef(null);

  useImperativeHandle(ref, () => ({
    handleDownloadPDF: async () => {
      setVisible(true);
      await new Promise((resolve) => setTimeout(resolve, 500));

      const element = document.getElementById("view-profile");
      html2canvas(element, { scale: 2 }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

        let name = "";
        const startDate = moment(props.startDate).format("DD/MM/YY");
        const endDate = moment(props.endDate).format("DD/MM/YY");
        if (
          props.report_name == "आरोपी विरुद्ध नव्याने दाखल गुन्ह्याची आकडेवारी"
        ) {
          name = "आरोपी विरुद्ध नव्याने दाखल गुन्ह्याची आकडेवारी";
        } else if (
          props.report_name ==
          "2 प्लस आरोपींवर नव्याने गुन्हा दाखल असलेल्या आरोपींची यादी"
        ) {
          name = "2 प्लस आरोपींवर नव्याने गुन्हा दाखल असलेल्या आरोपींची यादी";
        } else if (props.report_name == "2 प्लस आरोपी - सांख्यिकी") {
          name = "2 प्लस आरोपी - सांख्यिकी";
        } else if (props.report_name == "2 प्लस आरोपी - यादी") {
          name = "2 प्लस आरोपी - यादी";
        } else if (props.report_name == "हिस्ट्रीशिटर - सांख्यिकी") {
          name = "हिस्ट्रीशिटर - सांख्यिकी";
        } else if (props.report_name == "हिस्ट्रीशिटर - सांख्यिकी") {
          name = "हिस्ट्रीशिटर - यादी";
        } else {
          name = "2 प्लस आरोपी";
        }
        console.log("name", name);

        pdf.save(name + " " + startDate + " to " + endDate);
        setVisible(false);
        props.isNotloading();
      });
    },
  }));

  const columns = {
    new_arophi: [
      { title: "अ.क्र.", dataIndex: "index", key: "index", width: 50 },
      {
        title: "गुन्ह्याचे पोलिस ठाणे",
        dataIndex: "districtName",
        key: "districtName",
      },
      { title: "शरीराविषयक", dataIndex: "शरीराविषयक", key: "शरीराविषयक" },
      { title: "मालाविषयक", dataIndex: "मालाविषयक", key: "मालाविषयक" },
      {
        title: "अवैध वाळू विषयक",
        dataIndex: "अवैध वाळू विषयक",
        key: "अवैध वाळू विषयक",
      },
      {
        title: "अवैध दारु विषयक",
        dataIndex: "अवैध दारु विषयक",
        key: "अवैध दारु विषयक",
      },
      { title: "जुगारविषयक", dataIndex: "जुगारविषयक", key: "जुगारविषयक" },
      { title: "भाग - ६", dataIndex: "भाग - ६", key: "भाग - ६" },
      { title: "इतर", dataIndex: "इतर", key: "इतर" },
      { title: "एकुण", dataIndex: "एकुण", key: "एकुण" },
    ],
    arophi_count: [
      { title: "अ.क्र.", dataIndex: "index", key: "index", width: 50 },
      {
        title: "पोलिस ठाणे",
        dataIndex: "districtName",
        key: "districtName",
      },
      {
        title: "आकडेवारी",
        dataIndex: "crimeCount",
        key: "crimeCount",
      },
    ],
    arophi_count_list: [
      { title: "अ.क्र.", dataIndex: "index", key: "index", width: 50 },
      {
        title: "नाव",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "वय",
        dataIndex: "age",
        key: "age",
      },
      {
        title: "फोन नंबर",
        dataIndex: "mobileNumber",
        key: "mobileNumber",
      },
      {
        title: "आरोपीचे पोलिस ठाणे",
        dataIndex: "address",
        key: "address",
      },
      {
        title: "एकुण गुन्हे",
        dataIndex: "totalCrimeCount",
        key: "totalCrimeCount",
      },
    ],
    arophi_new_list: [
      { title: "अ.क्र.", dataIndex: "index", key: "index", width: 50 },
      {
        title: "नाव",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "वय",
        dataIndex: "age",
        key: "age",
      },
      {
        title: "फोन नंबर",
        dataIndex: "mobileNumber",
        key: "mobileNumber",
      },
      {
        title: "आरोपीचे पोलिस ठाणे",
        dataIndex: "address",
        key: "address",
      },
      {
        title: "एकुण गुन्हे",
        dataIndex: "totalCrimeCount",
        key: "totalCrimeCount",
      },
    ],
    history_sheeter_list: [
      { title: "अ.क्र.", dataIndex: "index", key: "index", width: 50 },
      {
        title: "नाव",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "वय",
        dataIndex: "age",
        key: "age",
      },
      {
        title: "फोन नंबर",
        dataIndex: "mobileNumber",
        key: "mobileNumber",
      },
      {
        title: "आरोपीचे पोलिस ठाणे",
        dataIndex: "address",
        key: "address",
      },
      {
        title: "एकुण गुन्हे",
        dataIndex: "totalCrimeCount",
        key: "totalCrimeCount",
      },
    ],
    two_plus: [
      { title: "अ.क्र.", dataIndex: "index", key: "index", width: 50 },
      {
        title: "आरोपीचे नाव",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "वय",
        dataIndex: "age",
        key: "age",
      },
      {
        title: "आरोपीचे पो. स्टे",
        dataIndex: "districtName",
        key: "districtName",
      },
      {
        title: "एकुण गुन्हे",
        dataIndex: "gunhaCount",
        key: "gunhaCount",
      },
    ],
  };

  const columnsToShow = columns[props.report_type]?.map((col) => ({
    ...col,
    title: <span style={{ fontSize: "18px" }}>{col.title}</span>,
  }));
  // props?.report_name === "हिस्ट्रीशिटर - सांख्यिकी"
  //   ? history[props.report_type]
  //   : columns[props.report_type];

  const dataSource = props?.rows?.map((item, index) => ({
    key: index,
    index: index + 1,
    ...item,
  }));

  return (
    <>
      {visible && (
        <div
          id="view-profile"
          ref={tableRef}
          // style={{
          //   padding: 20,
          //   background: "#fff",
          //   visibility: visible ? "visible" : "hidden",
          //   position: "absolute",
          //   left: 0,
          //   top: 0,
          // }}
          style={{ pointerEvents: visible && "none" }}
        >
          <Card
            footer={
              <div style={{ textAlign: "center", padding: "10px 0" }}>
                <p>Footer Content</p>
              </div>
            }
          >
            <Row
              justify="center"
              align="middle"
              style={{ marginBottom: 16, textAlign: "center" }}
            >
              <Col>
                <Title level={4} style={{ fontSize: "24px" }}>
                  घटक: {props?.cityName}
                </Title>
                <Title level={3} style={{ fontSize: "22px" }}>
                  {props?.report_name}
                </Title>
                <Title level={5} style={{ fontSize: "16px", marginBottom: 8 }}>
                  {props?.report_type != "history_sheeter"
                    ? "From: " +
                      moment(props.startDate && props.startDate).format(
                        "DD-MM-YYYY"
                      )
                    : null}{" "}
                </Title>
                <Title level={5} style={{ fontSize: "16px", marginBottom: 8 }}>
                  {props?.report_type != "history_sheeter"
                    ? "To: " +
                      moment(props.endDate && props.endDate).format(
                        "DD-MM-YYYY"
                      )
                    : null}
                </Title>
              </Col>
            </Row>

            <Table
              columns={columnsToShow}
              dataSource={dataSource}
              pagination={false}
              bordered
              style={{ fontSize: "18px" }}
            />
            <Footer
              style={{ textAlign: "center", backgroundColor: "transparent" }}
            >
              <Title style={{ fontSize: "14px", marginBottom: 8 }}>
                Generated At {moment(new Date()).format("DD MMM YYYY")} From
                Criminal Monitoring Intelligent System
              </Title>
            </Footer>
          </Card>
        </div>
      )}
    </>
  );
});

export default MyTable;
